<template>
  <div class="progress">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 400 400"
    >
    <defs>
      <linearGradient id="svg-gradient" gradientUnits="userSpaceOnUse" x1="100%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" style="stop-color:#4F7AEE" />
        <stop offset="100%" style="stop-color:#509DFD" />
      </linearGradient>
    </defs>
      <!-- 底部背景圆环 -->
      <circle
        cx="200"
        cy="200"
        :r="radius"
        :stroke="bgRingColor"
        :stroke-width="strokeWidth"
        fill="none"
      />
      <!-- 进度条圆环 -->
      <circle
        class="progress-bar"
        ref="progressbar"
        cx="200"
        cy="200"
        :r="radius"
        stroke="url('#svg-gradient')"
        :stroke-width="strokeWidth"
        fill="none"
        :stroke-linecap="strokeLinecap"
        transform="rotate(-90, 200, 200)"
        :stroke-dasharray="strokeDasharray"
        :stroke-dashoffset="strokeDashoffset"
      />
    </svg>
    <!-- 中间描述文字 -->
    <div class="progress-desc">
      <slot>{{rateMsg}}</slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "Progress",
  props: {
    rate: {
      type: Number,
      default: 0,
    },
    bgRingColor: {
      type: String,
      default: "#ebeef5",
    },
    ringColor: {
      type: String,
      default: "#67C23A",
    },
    strokeLinecap: {
      type: String,
      default: "round",
    },
    strokeWidth: {
      type: Number,
      default: 20,
    },
  },
  data:()=>({
    rateMsg: "0%",
  }),
  computed: {
    radius() {
      return 200 - this.strokeWidth / 2;
    },
    strokeDasharray() {
      return 2 * Math.PI * this.radius;
    },
    //角度偏移
    strokeDashoffset() {
      let val = 0;
      
      // 先截取当前数据到小数点后三位 （不会四舍五入）
      let tempVal = parseFloat(this.rate).toFixed(3)
      // 再取该数值长度-1的内容
      let rate = tempVal.substring(0, tempVal.length - 1)

      if (rate > 1) {
        rate = 1.00;
      } else if (rate < 0) {
        rate = 0.00;
      }
      let minVal = 2 * Math.PI * this.radius * rate;
      if (this.strokeLinecap === "round" && minVal>this.strokeWidth) {
        //去尾
        val = 2 * Math.PI * this.radius * (1 - rate) + this.strokeWidth/2;
      } else {
        val = 2 * Math.PI * this.radius * (1 - rate);
      }
      this.rateMsg = rate*100+"%";
      return val;
    },
  },
};
</script>
<style scoped>
.progress {
  position: relative;
  width: 100%;
  height: 100%;
}
.progress-desc {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: "Microsoft YaHei";
  font-size: 44px;/*no*/
  font-weight: 700;
  text-align: center;
}
.progress-bar {
  transition: stroke-dashoffset 1s ease;
}
</style>


// WEBPACK FOOTER //
// src/components/common/progress/annular.vue